<template>
  <div class="customers-notes-cards">
    <ms-form-filter
      :filters="filters"
      default-search="title"
      class="ms-filter"/>
    <div
      v-if="items.length > 0"
      class="main-cards">
      <div
        v-for="(item, index) in items"
        :key="index"
        class="content-note">
        <form-card :title="item.title">
          <div class="option-cards">
            <ms-actions
              :actions="actions"
              :row="item"/>
          </div>
          <div
            class="main-content"
            @click="onPreviewNote(item)">
            <p>{{ item.content }}</p>
            <footer>
              <i class="icon-calendar"/><p>{{ item.createdAt | date('DD/MM/YYYY') }}</p>
            </footer>
          </div>
        </form-card>
      </div>
    </div>
    <not-found
      v-else
      @addElement="newNote"/>
    <notes-preview
      v-if="showPrevNotePanel"
      :current-note="currentNote"/>
    <create-note v-if="showNotesPanel"/>
  </div>
</template>

<script>
import FormCard from '@/components/_shared/form-card'
import MsFormFilter from '@/components/_shared/ms-form-filter'
import MsActions from '@/modules/grid/ms-grid-actions'
import NotFound from '@/components/_shared/not-found'
import NotesPreview from '@/views/app/notes/notes-preview'
import CustomersGuards from '@/guards/customers.guards'
import CreateNote from '@/views/app/notes/notes-create-view'
import moment from 'moment'

export default {
  name: 'CustomersNotesCards',
  components: {
    FormCard,
    NotFound,
    NotesPreview,
    MsFormFilter,
    MsActions,
    CreateNote
  },
  data () {
    return {
      currentNote: null,
      actions: [
        {
          label: 'Consultar',
          icon: 'icon-edit',
          onClick: (row) => {
            this.getCurrentNote(row)
          }
        },
        {
          label: 'Eliminar',
          icon: 'icon-trash',
          onClick: (row) => {
            this.onDelete(row)
          }
        }
      ],
      filters: [
        {
          type: 'date',
          property: 'createdAt',
          props: {
            label: 'Fecha de creación'
          },
          queryFunction: function (val) {
            let _query
            if (!Array.isArray(val)) {
              _query = {
                'filters[whereBetween][createdAt]': val ? [moment(val).format('YYYY-MM-DD'), moment(val).add(1, 'day').format('YYYY-MM-DD')] : null
              }
            } else {
              _query = {
                'filters[whereBetween][createdAt]': [moment(val[0]).format('YYYY-MM-DD'), moment(val[1]).format('YYYY-MM-DD')]
              }
            }
            return _query
          }
        }
      ]
    }
  },
  computed: {
    items () {
      return this.$store.getters['notes/items']
    },
    showPrevNotePanel () {
      return this.$store.getters['app/showPrevNotePanel']
    },
    showNotesPanel () {
      return this.$store.getters['app/showNotesPanel']
    }
  },
  methods: {
    newNote () {
      this.$store.dispatch('app/toggleNotesPanel')
    },
    getCurrentNote (val) {
      this.$store.dispatch('app/togglePrevNotesPanel')
      this.currentNote = val
    },
    onPreviewNote (val) {
      this.$store.dispatch('app/togglePrevNotesPanel')
      this.currentNote = val
    },
    onDelete (item) {
      this.$confirm('Desea eliminar esta nota?', 'Eliminar Nota', {
        confirmButtonText: 'Aceptar',
        cancelButtonText: 'Cancelar',
        type: 'danger'
      }).then(() => {
        this.$store.dispatch('notes/delete', item.id)
          .then(({data}) => {
            this.$notify.success({
              group: 'app',
              title: 'Nota eliminada',
              message: 'La nota fue eliminada correctamente'
            })
            return this.$router.push({name: 'customers-info'})
          })
      })
    }
  },
  beforeRouteUpdate: CustomersGuards.onGetList('notes')
}
</script>

<style lang="scss" scoped>
.customers-notes-cards{
  .ms-filter{
    margin: -20px -20px 0 -20px;
  }
  .main-cards{
    .content-note{
      display: inline-block;
      padding: 10px;
      .el-card{
        margin: 5px;
        position: relative;
        color: $icon;
        float: left;
        .option-cards{
          position: absolute;
          top: 0;
          right: 0;
          .el-button{
            border: none;
            &:focus{
              background-color: #ffffff;
            }
            &:hover{
              background-color: #ffffff;
            }
          }
        }
        .main-content{
          height: 125px;
        }
        &:hover{
          cursor: pointer;
        }
        footer{
          position: absolute;
          bottom: 20px;
          height: 20px;
          display: flex;
          align-items: center;
          i{
            font-size: 15px;
            color: #CBCBCB;
            margin-right: 10px;
          }
          p{
            @include font-primary(15px);
            margin: 0;
            color: $icon;
          }
        }
      }
    }
  }

}

</style>



// WEBPACK FOOTER //
// src/modules/customers/customers-notes-cards.vue